import {Component, computed, input, output} from '@angular/core';
import {BillingTimesheetState, TimesheetSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {DurationPipe} from '../../pipes/duration.pipe';
import {PartyAvatar} from '../../../../components/avatar/party-avatar.component';
import {ElciaIcon} from '../../../../components/icon/icon';
import {TimesheetStateBadge} from '../../../../components/timesheet-state-badge/timesheet-state-badge';
import {Dot} from '../../../../components/dot/dot';
import {ElciaBadge} from '../../../../components/badge/badge';

@Component({
  selector: 'elcia-timesheet-grid',
  imports: [TableModule, DatePipe, TranslatePipe, ElciaButton, DurationPipe, PartyAvatar, ElciaIcon, TimesheetStateBadge, Dot, ElciaBadge],
  templateUrl: './timesheet-grid.html',
  styleUrl: './timesheet-grid.scss',
})
export class TimesheetGrid {
  timesheets = input.required<TimesheetSummary[]>();
  canValidate = input<boolean>(false);
  totalDuration = computed(() =>
    this.timesheets().reduce((sum, t) => sum + (t.durationInSeconds ?? 0), 0)
  );
  timesheetSelected = output<TimesheetSummary>();
  onDelete = output<TimesheetSummary>();
  onDuplicate = output<TimesheetSummary>();
  onStateChange = output<{ timesheet: TimesheetSummary; target: BillingTimesheetState }>();

  protected readonly BillingTimesheetState = BillingTimesheetState;

  onRowSelect(timesheet: TimesheetSummary): void {
    this.timesheetSelected.emit(timesheet);
  }

  changeState(event: Event, timesheet: TimesheetSummary, target: BillingTimesheetState): void {
    event.stopPropagation();
    this.onStateChange.emit({timesheet, target});
  }

  delete(event: Event, timesheet: TimesheetSummary): void {
    event.stopPropagation();
    this.onDelete.emit(timesheet);
  }

  duplicate(event: Event, timesheet: TimesheetSummary): void {
    event.stopPropagation();
    this.onDuplicate.emit(timesheet);
  }
}
